var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 285,
    viewBox: "-4 -4 268 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_law)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7624 0C9.31287 0 0.0357971 9.11792 0.0357971 20.371V257.783H189.629L202.605 238.566V0H20.7624Z",
    fill: "#15C887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7313 0H20.7624C9.31287 0 0.0357971 9.11792 0.0357971 20.371V257.783H37.7313V0Z",
    fill: "#1CA876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5296 238.624C7.49288 238.624 -1.90162 249.242 0.329572 261.361C1.97361 270.652 10.8984 277 20.5278 277C79.2435 277 143.831 277 202.546 277C198.436 264.535 198.436 251.089 202.546 238.624C143.478 238.624 78.5976 238.624 19.5296 238.624Z",
    fill: "#D2F0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.264 138.673L153.988 148.772L233.313 237.355C239.009 243.76 248.99 244.049 255.097 238.047C261.203 232.045 260.851 222.235 254.392 216.637L164.264 138.673Z",
    fill: "#FBD872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.465 134.08L149.279 140.16L156.005 146.77L162.191 140.69L155.465 134.08Z",
    fill: "#F6AF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.835 87.1494L101.591 134.565L130.487 162.966L178.731 115.55L149.835 87.1494Z",
    fill: "#FBD872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4526 134.633C91.1627 136.884 91.1627 140.462 93.4526 142.713L122.223 170.99C124.513 173.24 128.154 173.24 130.443 170.99C132.733 168.739 132.733 165.161 130.443 162.911L101.673 134.633C99.3829 132.441 95.7425 132.441 93.4526 134.633Z",
    fill: "#F6AF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.937 79.1758C147.647 81.4264 147.647 85.0043 149.937 87.2549L178.708 115.532C180.998 117.783 184.638 117.783 186.928 115.532C189.218 113.281 189.218 109.703 186.928 107.453L158.157 79.1758C155.867 76.9251 152.168 76.9251 149.937 79.1758Z",
    fill: "#F6AF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.007 191.188H73.0196C66.5608 191.188 61.2764 196.381 61.2764 202.729V211.559H155.75V202.729C155.75 196.381 150.524 191.188 144.007 191.188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_law",
    x: -4,
    y: 0,
    width: 268,
    height: 285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.f421e5df3975fc67640ac447a879487b.svg";
export { ForwardRef as ReactComponent };